

export const AVP_SERVICE_BARRIER_MANAGEMENT = 'BarrierManagement'
export const AVP_SERVICE_PROCESS_INTEGRITY = 'ProcessIntegrity'
export const AVP_SERVICE_ASSURANCE_SCORECARD = 'AssuranceScorecard'
export const AVP_SERVICE_ACTION_TRACKER = 'ActionManagement'